import { render, staticRenderFns } from "./exploracao.vue?vue&type=template&id=534f9c56&scoped=true&"
import script from "./exploracao.vue?vue&type=script&lang=js&"
export * from "./exploracao.vue?vue&type=script&lang=js&"
import style0 from "./exploracao.vue?vue&type=style&index=0&id=534f9c56&lang=scss&scoped=true&"
import style1 from "./exploracao.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534f9c56",
  null
  
)

export default component.exports